import JSEncrypt from 'jsencrypt';

const CryptoJS = window.CryptoJS;

export const sha256Sign = data => {
  return CryptoJS.SHA256(data).toString();
};

/**
 * @description aes加密
 * @param x
 * @param key
 * @returns {string}
 */
export const aesEncrypt = (x, key) =>
  CryptoJS.AES.encrypt(String(x), CryptoJS.enc.Hex.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).ciphertext.toString();

/**
 * @description aes解密
 * @param x
 * @param key
 * @returns {string}
 */
export const aesDecrypt = (x, key) => {
  const wordArray = CryptoJS.enc.Hex.parse(x);
  const base64String = CryptoJS.enc.Base64.stringify(wordArray);
  return CryptoJS.AES.decrypt(base64String, CryptoJS.enc.Hex.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};

/**
 * @description 生成32位的aes的key
 * @returns {string}
 * @constructor
 */
export const generateAesKey = () => {
  let key = '';
  const hex = '0123456789abcdef';

  for (let i = 0; i < 32; i++) {
    key += hex.charAt(Math.floor(Math.random() * 16));
  }
  return key;
};

function getBytesCountIs256(str) {
  let bytesCount = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    if (/^[\u0000-\u00ff]$/.test(c)) {
      bytesCount += 1;
    } else {
      bytesCount += 2;
    }
  }
  return !(bytesCount % 256);
}

export class RsaUtill {
  newPubkey =
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlzIsslaqOe6DLso4EzKuoGwIBnXdEt4cVG/FGzdkrxd64wuVe5qW5m5EA4jRa8Afh0318Ux8GXh1NjpYjePT5FOT2a5awLlV72VYuwJ9BiCtpniA4u9FL90Lv/TYU4sEzAoOxCom5uPWZsnBfnegow7DXEoAb6bv0PCv7WV1EiLE7XZLmXnTzBNP4yS0rwxK+31WGL1L3v1o5b2bvw6ZcVc7llVl5zUzeNck2wTWbknMJgmRItAdlxEhKIaxRoU7CcDCfqR7Jd8985GVjqP+YvPCuZ9YWrLCJmA+cBvqwlro3MfRXRqpmXC6uHfggQhPvGmygPrpOn3zxHV0eFDbxQIDAQAB';

  encrypt256(string) {
    const rsa = new JSEncrypt();
    // console.info(this.rsa);
    rsa.setPublicKey(this.newPubkey);
    // console.info(this.rsa);
    const k = rsa.getKey();
    const maxLength = ((k.n.bitLength() + 7) >> 3) - 11;
    try {
      let subStr = '';
      let encryptedString = '';
      let subStart = 0;
      let subEnd = 0;
      let bitLen = 0;
      let tmpPoint = 0;
      for (var i = 0, len = string.length; i < len; i++) {
        // js 是使用 Unicode 编码的，每个字符所占用的字节数不同
        const charCode = string.charCodeAt(i);
        if (charCode <= 0x007f) {
          bitLen += 1;
        } else if (charCode <= 0x07ff) {
          bitLen += 2;
        } else if (charCode <= 0xffff) {
          bitLen += 3;
        } else {
          bitLen += 4;
        }
        // 字节数到达上限，获取子字符串加密并追加到总字符串后。更新下一个字符串起始位置及字节计算。
        if (bitLen > maxLength) {
          subStr = string.substring(subStart, subEnd);
          encryptedString += k.encrypt(subStr);
          subStart = subEnd;
          bitLen -= tmpPoint;
        } else {
          subEnd = i;
          tmpPoint = bitLen;
        }
      }
      subStr = string.substring(subStart, len);
      encryptedString += k.encrypt(subStr);
      const is256 = getBytesCountIs256(encryptedString);
      if (is256) return hex2b64(encryptedString);
      else return false;
    } catch (ex) {
      return false;
    }
  }

  encrypt(string) {
    const s = this.encrypt256(string);
    if (s) return s;
    const s1 = this.encrypt256(string);
    if (s1) return s1;
    const s2 = this.encrypt256(string);
    if (s2) return s2;
    const s3 = this.encrypt256(string);
    if (s3) return s3;
    const s4 = this.encrypt256(string);
    if (s4) return s4;
  }
}

const b64pad = '=';
const b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
function hex2b64(h) {
  let i;
  let c;
  let ret = '';
  for (i = 0; i + 3 <= h.length; i += 3) {
    c = parseInt(h.substring(i, i + 3), 16);
    ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
  }
  if (i + 1 == h.length) {
    c = parseInt(h.substring(i, i + 1), 16);
    ret += b64map.charAt(c << 2);
  } else if (i + 2 == h.length) {
    c = parseInt(h.substring(i, i + 2), 16);
    ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
  }
  while ((ret.length & 3) > 0) {
    ret += b64pad;
  }
  return ret;
}

const BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';

export function int2char(n) {
  return BI_RM.charAt(n);
}
